import { FC } from "react";
import { Box, Container, Grid, Heading, Text, VStack } from "@chakra-ui/react";
import { LandingPageContent } from "@/constants/landingPages";

interface LandingBenefitsSectionProps {
  content: LandingPageContent["benefits"];
}

const iconMap: Record<string, string> = {
  "white-label": "✨",
  "custom-logic": "⚙️",
  "perfect-fit": "🎯",
};

export const LandingBenefitsSection: FC<LandingBenefitsSectionProps> = ({ content }) => (
  <Box py={{ base: "16", md: "24" }} bg="white">
    <Container maxW="7xl">
      <VStack spacing="16">
        {/* Section header */}
        <VStack spacing="4" textAlign="center" maxW="800px" mx="auto">
          <Heading as="h2" fontSize={{ base: "3xl", md: "4xl" }} color="gray.900">
            {content.title}
          </Heading>
          <Text fontSize={{ base: "lg", md: "xl" }} color="gray.600" lineHeight="1.7">
            {content.subtitle}
          </Text>
        </VStack>

        {/* Benefits grid */}
        <Grid
          templateColumns={{
            base: "1fr",
            md: "repeat(3, 1fr)",
          }}
          gap="8"
          w="100%"
        >
          {content.items.map((benefit) => (
            <Box
              key={benefit.id}
              bg="gray.50"
              borderRadius="xl"
              p="8"
              textAlign="center"
              transition="all 0.3s"
              _hover={{
                transform: "translateY(-4px)",
                boxShadow: "lg",
                bg: "white",
              }}
            >
              <VStack spacing="4">
                <Box fontSize="4xl">{iconMap[benefit.id] || "📦"}</Box>
                <Heading as="h3" fontSize="xl" color="gray.900">
                  {benefit.title}
                </Heading>
                <Text color="gray.600" lineHeight="1.7">
                  {benefit.description}
                </Text>
              </VStack>
            </Box>
          ))}
        </Grid>
      </VStack>
    </Container>
  </Box>
);
